import {
    TOGGLE_LOADING_INDICATOR,TOGGLE_ERROR_INDICATOR,
    SET_MESSAGE_RESPONSE,MessageResponse,SET_ERROR_MESSAGE_RESPONSE,SET_WARNING_MESSAGE_RESPONSE_POPUP,SET_MY_USER
} from "./types";

export function toggleWarningErrorPopupIndicator(showWarningPopup: boolean) {
    return {
        type: SET_WARNING_MESSAGE_RESPONSE_POPUP,
        payload: showWarningPopup
    };
}

export function toggleShowMyUser(showMyUser: boolean) {
    return {
        type: SET_MY_USER,
        payload: showMyUser
    };
}

export function toggleLoadingIndicator(showLoading: boolean) {
    return {
        type: TOGGLE_LOADING_INDICATOR,
        payload: showLoading
    };
}

export function setMessageResponse(messageResponse: MessageResponse | null) {
    return {
        type: SET_MESSAGE_RESPONSE,
        payload: messageResponse
    };
}
export function setErrorMessageResponse(messageResponse: MessageResponse | null) {
    return {
        type: SET_ERROR_MESSAGE_RESPONSE,
        payload: messageResponse
    };
}

export function toggleErrorIndicator(showError: boolean) {
    return {
        type: TOGGLE_ERROR_INDICATOR,
        payload: showError
    };
}